import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const HeaderButton = styled(Button)(({ theme }) => ({
  padding: 0,
  color: theme.palette.oldText.main,
  lineHeight: 1,
  fontSize: "0.75rem",
  fontWeight: 400,
  textTransform: "unset",
  minWidth: "unset",
  textAlign: "left",
  ["&:hover"]: {
    backgroundColor: "transparent",
    opacity: 0.8,
    transition:
      "opacity 0.2s ease-in-out, color 0.2s ease-in-out, background-color 0.2s ease-in-out",
  },
  ["&:active"]: {
    backgroundColor: "transparent",
    opacity: 0.6,
  },
  ["& svg"]: {
    fontSize: "1rem",
    marginRight: theme.spacing(1),
  },
}));
